const PbxxRecord = require('../pbxx_record')

module.exports = class TwitterAccount extends PbxxRecord {
  static get class_name() {
    return 'TwitterAccount'
  }
}
